import ListStockFisik from "./ListStockFisik";

export default ListStockFisik;
